<script>
import Layout from '@layouts/main';
import CostTypeForm from '@views/costTypes/form';

export default {
  components: {
    Layout,
    CostTypeForm,
  },
  page() {
    return {
      title: this.$t('titles.create_cost_type'),
    };
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: this.$t('titles.home'),
          to: { name: 'home.index' },
        },
        {
          text: this.$t('titles.cost_types'),
          to: { name: 'costTypes.index' },
        },
        {
          text: this.$t('titles.create_cost_type'),
          active: true,
        },
      ],
    };
  },
  methods: {
    create() {
      this.$router.push({
        name: 'costTypes.index',
      });
    },
  },
};
</script>

<template>
  <Layout>
    <b-breadcrumb :items="breadcrumbItems" />
    <b-card
      :border-variant="!errors.items.length ? 'dark' : 'danger'"
      :header="$t('titles.create_cost_type')"
      header-tag="header"
      :header-bg-variant="!errors.items.length ? 'dark' : 'danger'"
      header-text-variant="white"
      class="mb-3"
    >
      <CostTypeForm @submitted="create" />
    </b-card>
  </Layout>
</template>
